import { render, staticRenderFns } from "./Bimini_wineList.vue?vue&type=template&id=00c6bd70&scoped=true"
import script from "./Bimini_wineList.vue?vue&type=script&lang=ts"
export * from "./Bimini_wineList.vue?vue&type=script&lang=ts"
import style0 from "./Bimini_wineList.vue?vue&type=style&index=0&id=00c6bd70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c6bd70",
  null
  
)

export default component.exports